import { CookieService } from 'ngx-cookie-service';
import { Component, OnInit, OnDestroy, Testability, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/finally';

import { UserSession } from '../shared/user-session';
import { TouchFaceIdService } from '@mem-shared/touchFaceId.service';
import { NativeIntegrationService } from '@mem-shared/native-integration.service';
import { UtilService } from './../shared/util.service';

import { NewLoginWidgetContextType } from './models/new-login-widget-types';
import { NewLoginWidgetService } from './new-login-widget.service';
import { NewLoginWidgetControls } from './new-login-widget-custom-controls/new-login-widget.controller';
import { logOktaDataInTable } from './models/new-login-widget-logger';
import { ClientId_SHOPPER } from 'app/login/client_id';
import { ClientId_MEMBER } from 'app/login/client_id';
import { environment } from './../../environments/environment';


declare var OktaSignIn: any;


@Component({
  selector: 'mem-okta-login',
  templateUrl: './new-login-widget.component.html',
  styleUrls: [
   './new-login-widget.component.scss',
    './new-login-widget-styles/common-styles.scss',
    './new-login-widget-styles/login-page.scss',
    './new-login-widget-styles/forgot-password.scss',
    './new-login-widget-styles/mfa-verify.scss',
    './new-login-widget-styles/account-recovery.scss',
    './new-login-widget-styles/account-unlock.scss',
    './new-login-widget-styles/password-reset.scss'  ]
})
export class NewLoginWidgetComponent extends NewLoginWidgetControls implements OnInit, OnDestroy {

  signIn: any;
  showLoader: boolean;
  @ViewChild('learnMoreModal') learnMoreModal: ModalDirective;

  // Touch id and face id variables
  touchIdStatusFlag: string;
  iOSCompatible: string;
  bioIdType: string;
  touchIdAuthenticationFlag
  // faceIdAuthenticationFlag
  touchFaceIdValue: string;
  prepopulatedUsername: string;
  touchIDshow = false;
  iosCompatibleCheck: boolean = false;
  sharecare2Login: boolean = false;
  incorrectPassword = false;
  loginPasswordLocked = false;
  antiPhishing: string = null;
  rememberMe: boolean = false;
  wrongpass: string = '';
  // loginErrors = LOGIN_ERRORS;
  loginError: string = '';
  // To Check weather we are in login page or not.
  pageType: NewLoginWidgetContextType = { controller: 'primary-auth' };
  previousPageType: NewLoginWidgetContextType = { controller: 'primary-auth' };
  oktaDebugMode = false;
  oktaInitialRender: boolean = true;
  results: any;
  recoveryToken = this.getParameterByName('rt', null);
  isPasswordReset: boolean;
  isHidePassword: boolean;
  type: string = 'password';
  show: boolean = false;
  state: any;
  sourcePortal = 'MEMBER';
  zenv = 'pit';
  clientType = '';
  clientId;
  code;
  sessionToken;


  constructor(
    private loginSvc: NewLoginWidgetService,
    private route: ActivatedRoute,
    private router: Router,
    public userSession: UserSession,
    private touchFaceIdSvc: TouchFaceIdService,
    private utilService: UtilService,
    private cookieService: CookieService,
    private nativeSvc: NativeIntegrationService,
  ) {
     super(router);
  }


  ngOnInit() {
       this.route.queryParams
      .subscribe(params => {
        if(params.clientType)
        {
          this.clientType = params.clientType;
        }
        this.userSession.setLocalStorageItem('clientType', this.clientType);
        if (params.sourcePortal) {
          this.sourcePortal = params.sourcePortal;
        }
        this.userSession.setLocalStorageItem('sourcePortal', this.sourcePortal);

        if (params.zenv) {
          this.zenv = params.zenv;
        }
        this.userSession.setLocalStorageItem('zenv', this.zenv);
        this.userSession.setSession('zenv', this.zenv);
        if(params.state)
        {
          this.state = params.state;
          this.userSession.setLocalStorageItem('state',this.state);
        }
        if (params.code)
        {
          this.code = params.code;
          this.userSession.setLocalStorageItem('code', this.code);
        }
      });
     this.clientId = this.getClientID(this.sourcePortal);
    // touchid and faceid code start 
    if (this.router.url === '/login' && this.userSession.getSession('previousUrl') !== '/logout') {
      this.touchFaceIdSvc.checkTouchIDCompatibility(this.utilService.getNativeOS());
    }
    this.touchFaceIdValue = this.userSession.getLocalStorageItem('touchid');
    this.touchIdStatusFlag = this.userSession.getLocalStorageItem('touchIdStatus');
    if (this.touchIdStatusFlag === "true") {
      this.loginSvc.touchIDshow = true;
      // comment for check enable touch id checkbox
      if (this.userSession.getLocalStorageItem('touchid') == "true") {
        //  this.loginForm.patchValue({ faceTouchCheck: true });//need to add logic to set checkbox value using jquery
      }
      this.userSession.setLocalStorageItem('touchid', true, { persist: true });
      this.loginSvc.touchIdEnabledUserId = this.userSession.getLocalStorageItem('registeredUserId');
      this.userSession.setLocalStorageItem('loginUserName', this.loginSvc.touchIdEnabledUserId ? this.loginSvc.touchIdEnabledUserId : null, { persist: true });
      // this.loginForm.patchValue({ userName: this.userSession.getLocalStorageItem('loginUserName'), });
      this.userSession.setLocalStorageItem('loginPassword', null, { persist: true });
    }
    // touchid and faceid code end

    // check the behavior of the touch and faceid
    this.checkTouchEnable();

    // Controlling okta debug mode
    if (window.location.origin.match(/[(localhost)(membersit)]/)) {
      this.oktaDebugMode = true;
    }

    // Initialize okta widget
    this.oktaLoginInit();
  }


  getParameterByName(name, url) {
    // console.log('inside func, fetching the extracted req url part: redirectUrl-', url);
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    // console.log('inside func, name-', name);
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    // console.log('inside func, regex-', regex);
    this.results = regex.exec(url);
    // console.log('inside func, before if results-', this.results);
    if (!this.results) {
      return null;
    }
    if (!this.results[2]) {
      return '';
    }
    // console.log('inside func, after if results-', this.results);
    return decodeURIComponent(this.results[2].replace(/\+/g, ' '));
  }
  //setting baseurl for different environments
  getBaseUrl() {
  var baseUrl;
  if (window.location.hostname == 'membersp.carefirst.com' || window.location.hostname == 'member.carefirst.com') {
    baseUrl = "https://login.carefirst.com";
  }
  else {
    baseUrl = "https://logintest.carefirst.com";
  }
  return baseUrl;
}
  /**
   * Logic for initializing okta widget.
   */
  oktaLoginInit() {
    /**
     * Okta widget configurations.
     */
    const config = {
      language: 'en',
      i18n: {
        'en': {
          'primaryauth.submit': 'Log In',
          'remember': 'Remember my username',
          'error.username.required': 'Please enter your username',
          'primaryauth.username.placeholder': 'Username',
          'error.password.required': 'Please enter your password',
          'primaryauth.password.placeholder': 'Password',
          // "oform.errorbanner.title": ' ',
          "oform.error.unexpected": 'The username and password combination is incorrect.',
          "errors.E0000004": 'The username and password combination is incorrect.',
          "goback": 'Back to Login',
          // "rememberDevice.timebased": "Remember me on this device for {}",
          "rememberDevice.devicebased": "Remember me on this device",
          "email.code.label": "Enter 6 Digit Code",
          "mfa.challenge.enterCode.placeholder": "Enter 6 Digit Code",
          "mfa.challenge.enterCode.tooltip": "Enter 6 Digit Code",
          "email.enroll.enterCode": "Enter 6 Digit Code",
          "password.forgot.email.or.username.placeholder": "Username",
          "password.forgot.email.or.username.tooltip": "Username",
          "account.unlock.email.or.username.placeholder": "username",
          "account.unlock.email.or.username.tooltip": "username",
          "password.forgot.sendText": "Text Message",
          "password.forgot.sendEmail": "Email",
          "account.unlock.sendText": "Text Message",
          "account.unlock.sendEmail": "Email",
          "email.button.resend": "Re-send code",
          "authfactor.challenge.soft_token.invalid_passcode" : "Your code doesn't match our records. Please try again.",
          "errors.E0000069" : "Your account is locked because of too many authentication attempts.",
          "oform.errorbanner.title" : "We found some errors. Please review the form and make corrections."
          // "errors.E0000069": 'Your account is locked because of too many authentication attempts.',
          // "errors.E0000047": 'You exceeded the maximum number of requests. Try again in a while.'
        }
      },

      features: {
        registration: false,
        rememberMe: true,
        multiOptionalFactorEnroll: false,
        selfServiceUnlock: true,
        smsRecovery: true,
        emailRecovery: true,
        callRecovery: false,
        showPasswordToggleOnSignInPage: true,
        router: false,
        scrollOnError: false
      },
      recoveryToken: this.recoveryToken,
      baseUrl: this.getBaseUrl()
    };

    // console.log(config);

    // creation of new okta sign in object.
    this.signIn = new OktaSignIn(config);
    this.loginSvc.oktaLoginWidget = this.signIn;

    // once the okta sign component is loaded then update the UI as below using update UI method.
    this.signIn.on("ready", (context: NewLoginWidgetContextType) => {
      this.oktaDebugMode && logOktaDataInTable('ready', context);
      this.handleOktaReadyEvent(context);
    });

    this.signIn.on('afterRender', (context: NewLoginWidgetContextType) => {
      this.oktaDebugMode && logOktaDataInTable('afterRender', context);
      this.handleOktaAfterRenderEvent(context);
    });

    this.signIn.on('afterError', (context: NewLoginWidgetContextType, error) => {
      this.oktaDebugMode && logOktaDataInTable('afterError', context, "Context");
      this.oktaDebugMode && logOktaDataInTable('afterError', error, "Error");
      this.handleOktaAfterErrorEvent(context, error);
    });

    // rendering the ui and handling the success and failure events.
    this.signIn.renderEl({
      // Assumes there is an empty element on the page with an id of 'okta-login-container'
      el: '#okta-login-container'
    }).then((res) => {
      if (res.status === 'SUCCESS') {
        let landingURL;
        if (this.sourcePortal === 'MEMBER')
        {
         landingURL = window.location.origin + '/CFRouter/redirect?p=%2Fmos%2F%23%2Flanding';
        if (this.utilService.getNativeOS() === 'iOS' || this.utilService.getNativeOS() === 'Android') {
          landingURL = this.nativeSvc.getTargetURL() + '/CFRouter/redirect?p=%2Fmos%2F%23%2Flanding';
        }
          res.session.setCookieAndRedirect(landingURL);
          
        }
        else {
         
          landingURL = window.location.origin + `/CFRouter/redirect?p=/login/v2/jwt/${this.clientId}`;
          if (this.utilService.getNativeOS() === 'iOS' || this.utilService.getNativeOS() === 'Android') {
          landingURL = this.nativeSvc.getTargetURL() + `/CFRouter/redirect?p=/login/v2/jwt/${this.clientId}`;
           }
 
          res.session.setCookieAndRedirect(landingURL);
         
        }
      }
      // if (res.status === 'LOCKED_OUT') {
      //   this.router.navigate(['/login/accountLocked']);
      // }
    }).catch(function (error) {
      // Handle error
      console.error(error);
    });
  }

  /**
   * Method will be called when the okta widget was initialized
   * @param context OktaContext DataType
   */
  handleOktaReadyEvent(context: NewLoginWidgetContextType) {
    if (context.controller === 'primary-auth') {
      // this.oktaInitialRender = false;
      // this.updateUI();
    }
  }

  /**
   * Method will be called when the okta widget was rerendered.
   * i.e, when there is a change in screens of okta widget this method is called by default.
   * @param context OktaContext DataType
   * @returns none
   */
  handleOktaAfterRenderEvent(context: NewLoginWidgetContextType) {
    this.previousPageType = { ...this.pageType };
    this.pageType = context;
    // console.log(this.pageType, this.previousPageType);
    switch (context.controller) {
      case 'primary-auth':
        this.resetDefaultValues();
        if (this.oktaInitialRender) {
          // this.oktaInitialRender = false;
          return this.updateUI();
        } else {
          return;
        }
      case 'account-unlock':
        return this.updateAccountRecoveryFlowUI(context);
      case 'enroll-choices':
        return this.updateMFAFlowUI(context);
      case 'mfa-verify':
        return this.updateMFAVerificationFlowUI(context);
      case 'password-expired':
        return this.updatePasswordExpiredFlowUI(context);
      case 'forgot-password':
        return this.updateForgotPasswordFlowUI(context);
      case 'recovery-challenge':
        return this.updateForgotPasswordSMSConfirmationFlowUI(context);
      case 'password-reset-email-sent':
        return this.updateForgotPasswordEmailConfirmationFlowUI(context);
      case 'password-reset':
        // this.isPasswordReset = true;
        return this.updatePasswordResetFlowUI(context);
      case 'account-unlocked':
        return this.updateAccountUnlockedScreen(context);
      default:
        this.pageType = context;
    }
  }

  /**
   * Method is called when there is an error occurred either because of UI or an API call.
   * @param context OktaContext DataType
   * @param error Default okta error response type
   */
  handleOktaAfterErrorEvent(context:NewLoginWidgetContextType, error: any) {
    if (this.getUserName() && this.getUserName().toLowerCase() === 'bias123') {
      this.userSession.setCookie("theUserID", "BIAS123")
      this.router.navigateByUrl('/landing');
    }
  }

  /**
   * Logic to update ui as per new login component.
   */
  updateUI() {
    // adding login page footer
    // const innerHtml = $(".o-form-button-bar").first().html();
    // $(".o-form-button-bar").first().html(`
    //   <div class="login-footer-block">
    //     <div class="forgot-username-block mt-2 ">
    //       <span>
    //         <a href="javascript:void(0)"  class="link-font custom-link-color" id="oktaForgotUsername">Forgot Username?</a>
    //       </span>
    //     </div>
    //     <div class="forgot-password-block mt-2">
    //       <span>
    //         <a href="javascript:void(0)"  class="link-font custom-link-color" id="oktaForgotPassword">Forgot Password?</a>
    //       </span>
    //     </div>
    //     <div class="learn-more-block mt-2">
    //       <span class="color-grey">New log in updates.<br  class="d-md-none d-block">
    //         <a href="javascript:void(0)" class="link-font custom-link-color" id="oktaLearnMore">Learn more</a>
    //       </span>
    //     </div>
    //     <div class="sign-in-button-block">
    //       ${innerHtml}
    //     </div>
    //   </div>
    // `)


    // Logic to remove default okta heading.
    $('.okta-form-title.o-form-head').remove();


    // Logic for adding placeholders in username and password fields.
    $("#okta-signin-username").attr('placeholder', "Enter username");
    $("#okta-signin-password").attr('placeholder', "Enter password");
    // Logic to change the class of the existing sign in button to bootstrap button class
    $('#okta-signin-submit').removeClass("button button-primary").addClass("btn btn-primary btn-block");


    // Logic to add margin to sign in button
    $(".sign-in-button-block").first().addClass("pl-md-9");

    // Logic's to handel click events on forgot username, forgot password and learn more links.
    $("#oktaForgotUsername").on("click", () => {
      this.goToRecovery();
    })
    $("#oktaForgotPassword").on('click', () => {
      $("a.link.js-forgot-password")[0].click()
    })
    $("#oktaLearnMore").on("click", () => {
      this.learnMoreModal.show();
    })

    // replacing existing remember me with custom remember me checkbox
    const rememberMeParent = $(".o-form-input-name-remember").first()
    rememberMeParent.hide();
    const rememberMeChild = $("<span>").addClass("o-form-input-name-remember").html(`
      <div class="rememberme">
        <input type="checkbox" name="input7" id="input7" class="custom-checkbox-style">
        <label for="input7" class="">Remember my username</label>
      </div>
    `);
    rememberMeParent.parent().append(rememberMeChild);

    if (this.userSession.getCookie("ln")) {
      $("#input7").prop("checked", true);
    }

    $("#input7").change(() => {
      console.log("Checked: ", $("#input7").is(":checked"))
      if ($("#input7").is(":checked")) {
        this.userSession.setCookie("ln", this.getUserName())
      } else {
        this.userSession.deleteCookie("ln")
      }
    });
    //Logic for adding fingerprint checkbox
    this.addBioIdCheckBox();
  }

  /**
   * logic to add biometric check box.
   */
  addBioIdCheckBox() {
    console.log('in assBioID checkbox');
    if ((this.utilService.getNativeOS() === 'iOS' || this.utilService.getNativeOS() === 'Android') && this.iosCompatibleCheck) {
      // if (true) {
      const passwordEle = $(".o-form-fieldset-container").first()
      const newFingerPrintEle = $("<div>")
        .attr("data-se", "o-form-fieldset")
        .addClass("o-form-fieldset o-form-label-top margin-btm-0")
        .html(`
            <div data-se="o-form-input-container" class="o-form-input">
              <span data-se="o-form-input-fingerprint-scanner" class="o-form-input-name-fingerprint-scanner">
                <div class="fingerprint-checkbox">
                  <input type="checkbox" name="fingerprint" id="fingerprint" class="custom-checkbox-style">
                  <label for="fingerprint" class="">Enable ${this.bioIdType}</label>
                </div>
              </span>
            </div>
          `)
      passwordEle.append(newFingerPrintEle);

      //    document.getElementById('fingerprint').addEventListener('change', (e: any) => {
      // console.log("changed");
      // });

      $("#fingerprint-input").on('change', (e: any) => { console.log("changed"); });

      // tracking signin button click event
      //  document.getElementById('okta-signin-submit').addEventListener("click", (e) => {
      //  this.signInButtonClickEventCall(e);
      // })
      $("#okta-signin-submit").on("click", (e) => { this.signInButtonClickEventCall(e); })
    }

    this.changeTheStatusOfCheckboxInTheForm();

  }

  /**
   * Method for signin button click event
   * @param e Mouse event - which is useful for tracking sign in button click event.
   */
  signInButtonClickEventCall(e: any) {
    console.log('in sign in button');
    if (this.getFingerprintCheckboxStatus()) {
      e.preventDefault();
      this.TouchIDLogin();
    }
  }

  /**
   * Method to change the checkbox status of enable fingerprint checkbox.
   * @param status checkbox status true for check and false for uncheck
   */
  changeFingerprintCheckboxToCheckedORUnchecked(status: boolean) {
    
    console.log('changeFingerprintCheckboxToCheckedORUnchecked == true');
    //alert('changeFingerprintCheckboxToCheckedORUnchecked == true');
    console.log('fingerprint == true');
    $("#fingerprint").prop('checked', status);
    // const fingerprintControl: HTMLInputElement = <HTMLInputElement>document.getElementById('fingerprint');
    // fingerprintControl.checked = status;  return $("#fingerprint").val();
  }

  /**
   * Gives the enable fingerprint checkbox status.
   * @returns fingerprint checkbox status 
   * - true - if checked
   * - false - if unchecked
   */
  getFingerprintCheckboxStatus(): boolean {
    console.log('getFingerprintCheckboxStatus');
    //return $('#fingerprint').val();
    // const fingerprintControl: HTMLInputElement = <HTMLInputElement>document.getElementById('fingerprint');
    // return fingerprintControl.checked;
    return $('#fingerprint').is(':checked')
  }

  /**
   * Gives the Username from the form.
   * @returns Username  
   */
  getUserName(): string {
    //  const username: HTMLInputElement = <HTMLInputElement>document.getElementById('okta-signin-username');
    // return username.value;
    // return $("#okta-signin-username").val()
    return <string>$("#okta-signin-username").val();
  }

  /**
   * Gives the Password from the form.
   * @returns Password  
   */
  getUserPassword(): string {
    //return $("#okta-signin-password").val();
    // const password: HTMLInputElement = <HTMLInputElement>document.getElementById('okta-signin-password');
    // return password.value;
    return <string>$("#okta-signin-password").val();
  }

  /**
   * method to remove signin page.
   */
  oktaWidgetHide() {
    this.signIn.remove();
  }

  /**
   * method for navigating into register page.
   */
  registerNow() {
    this.router.navigate(['/registration/step1']);
  }

  /**
   * method for navigating into recovery page.
   */
  goToRecovery() {
    this.loginSvc.trackGAEvent("Okta","Okta Account Recovery");
    this.router.navigate(['/accountRecovery/step1']);
    // this.router.navigate(['https://logintest.carefirst.com/signin/forgot-password']);
  }

  /**
   * cleaning all data on component destruction.
   */
  ngOnDestroy() {
    this.oktaInitialRender = false;
    this.oktaWidgetHide();
  }

  /**
   * TouchId and FaceTD code
   */
  checkTouchEnable() {
    console.log('In checkTouchEnable method');
    //alert('In checkTouchEnable method');
    if (this.router.url === '/login' && this.userSession.getSession('previousUrl') !== '/logout') {
      this.touchFaceIdSvc.checkTouchIDCompatibility(this.utilService.getNativeOS());
    }

    this.antiPhishing = this.userSession.getLocalStorageItem('antiPhishing');

    this.touchFaceIdValue = this.userSession.getLocalStorageItem('touchid');
    this.touchIdStatusFlag = this.userSession.getLocalStorageItem('touchIdStatus');
    if (this.touchIdStatusFlag === "true") {
      console.log('touchIdStatusFlag == true');
      //alert('touchIdStatusFlag == true');
      this.loginSvc.touchIDshow = true;
      // Added code for fixing SIT issue         
      // comment for check enable touch id checkbox
      if (this.userSession.getLocalStorageItem('touchid') == "true") {
        this.changeFingerprintCheckboxToCheckedORUnchecked(true);
      }
      this.userSession.setLocalStorageItem('touchid', true, { persist: true });
      this.loginSvc.touchIdEnabledUserId = this.userSession.getLocalStorageItem('registeredUserId');
      this.userSession.setLocalStorageItem('loginUserName', this.loginSvc.touchIdEnabledUserId ? this.loginSvc.touchIdEnabledUserId : null, { persist: true });
      this.userSession.setLocalStorageItem('loginPassword', null, { persist: true });
    }

    // Call TouchID Service function to check Touch ID Compatibility   
    // console.log('Touch ID Compatibility service');

    this.iOSCompatible = this.userSession.getLocalStorageItem('compatible');
    console.log('is ioscompatible check');
    if (this.utilService.getNativeOS() === "Android") {
      this.bioIdType = 'Fingerprint Login';
    } else {
      this.bioIdType = this.userSession.getLocalStorageItem('compatible') === 'faceID' ? "Face ID" : "Touch ID";
    }
    this.touchIdStatusFlag = this.userSession.getLocalStorageItem('touchIdStatus');
    this.touchIdAuthenticationFlag = this.userSession.getLocalStorageItem("touchIdAuth");
    if (this.iOSCompatible == "true" || this.iOSCompatible == "faceID") {
      this.iosCompatibleCheck = true;
    }

    if (this.userSession.getCookie('isRememberMeInfo') == 'Y') {
      let userId = this.userSession.getCookie('theUserID') //  securedUser.getCookie('theUserID') ;
      this.userSession.setLocalStorageItem('loginUserName', userId ? userId : null, { persist: true });
      this.userSession.setLocalStorageItem('loginPassword', null, { persist: true });
    } else if ((this.utilService.getNativeOS() === "Android" || this.utilService.getNativeOS() === "iOS")
      && this.userSession.getLocalStorageItem('isRememberMeInfo') == "Y") {
      let userId = this.userSession.getLocalStorageItem('theUserID');
      this.userSession.setLocalStorageItem('loginUserName', userId ? userId : null, { persist: true });
      this.userSession.setLocalStorageItem('loginPassword', null, { persist: true });
      if (this.touchIdStatusFlag == "true") {
        let touchIdEnabledUserId = localStorage.getItem('registeredUserId'); //console.log('touchIdEnabledUserId:' + touchIdEnabledUserId);
        this.userSession.setLocalStorageItem('loginUserName', touchIdEnabledUserId ? touchIdEnabledUserId : null, { persist: true });
        this.userSession.setLocalStorageItem('loginPassword', null, { persist: true });
      }
    }
  }

  /**
   * method to change the checkbox behavior in login form.
   */
  changeTheStatusOfCheckboxInTheForm() {
    if (this.userSession.getLocalStorageItem('isRememberMeInfo') == 'Y' && this.userSession.getLocalStorageItem('isRememberUserName')) {
      this.userSession.setLocalStorageItem('loginUserName', this.userSession.getLocalStorageItem('isRememberUserName'), { persist: true })
    } else if (this.utilService.getNativeOS() === "Android" || this.utilService.getNativeOS() === "iOS") {
      //  console.log('rememberMeValue');
      let username = '';
      if (this.userSession.getLocalStorageItem('rememberMeValue') == "true") {
        this.rememberMe = true; //console.log("this.rememberMe" + this.rememberMe);
        username = this.userSession.getLocalStorageItem('rememberMe');
      } else if (this.userSession.getLocalStorageItem('rememberMeValue') == "false") {
        this.rememberMe = false; //console.log("this.rememberMe" + this.rememberMe);
        username = '';
      } else {
        this.rememberMe = false;
        username = '';
      }
    } else {
      this.changeFingerprintCheckboxToCheckedORUnchecked(false);
    }

    if (this.userSession.getLocalStorageItem('touchid') == "true") {
      this.changeFingerprintCheckboxToCheckedORUnchecked(true);
    } else {
      this.changeFingerprintCheckboxToCheckedORUnchecked(false);
    }

    // clear cookies for native  
    if (this.utilService.getNativeOS() !== 'web') {
      // alert('call  invokeNativeService service for clear cookie');
      this.nativeSvc.invokeNativeService(this.utilService.getNativeOS(), 'clearCookie', '');
    }

    //fix for Android:login page Enable Touch Id invisible at first login attempt //Android-Touch
    if (this.utilService.getNativeOS() === "Android") {
      this.isLoginLoaded();
    }
  }

  /**
   * Method for touch id login
   */
  TouchIDLogin() {
    console.log('In TouchIDLogin method ');
    this.loginSvc.trackGAEvent("Okta","Okta TouchID Login");
    const password = '';
    // this.userSession.setSession('passwordEbiz', this.loginForm.get('loginPassword').value);
    // this.userSession.setSession('passwordForEbiz', this.loginForm.get('loginPassword').value);
    let username = this.getUserName();
    let userPassword = this.getUserPassword();
    // // Use for native condition
    this.nativeSvc.loggingInUserName = username.toUpperCase().trim();
    this.nativeSvc.loggingInPassword = userPassword// this.loginForm.controls.loginPassword.value;
    this.nativeSvc.loggingInUserName = username;
    let touchIdStatusFlag = this.userSession.getLocalStorageItem('touchIdStatus');
    let updatePwdFlag = this.userSession.getLocalStorageItem('updatePasswordFlag');
    if (touchIdStatusFlag == "true" && updatePwdFlag == "true") {
      if (this.utilService.getNativeOS() === "iOS" || this.utilService.getNativeOS() === "Android") { //Android-Touch
        this.nativeSvc.invokeNativeService(this.utilService.getNativeOS(), "updateChangedPassword", password);
      }
    }

    if (this.utilService.getNativeOS() === "iOS" || this.utilService.getNativeOS() === "Android") { //Android-Touch
      if (this.userSession.getLocalStorageItem('isEnableTouchIDChecked') === 'false') {
        if (this.userSession.getLocalStorageItem('isRememberMeChecked') === 'false') {
          if (this.utilService.getNativeOS() === "iOS" || this.utilService.getNativeOS() === "Android") { //Android-Touch
            this.userSession.setLocalStorageItem('theUserID', '');
            this.userSession.setLocalStorageItem('touchIdStatus', 'false', { persist: true });//Issue #4 fixed 02/05
            this.userSession.setLocalStorageItem('touchIdAuth', 'false', { persist: true });
            if (this.userSession.getLocalStorageItem('newUserNoTouhIdEnabled') === 'false') {
              let touchIdStatusFlag = this.userSession.getLocalStorageItem('touchIdStatus');
              this.nativeSvc.invokeNativeService(this.utilService.getNativeOS(), "updateTouchIdStatusFlag", touchIdStatusFlag);
            }
            let prepopulatedUsername = this.userSession.getLocalStorageItem("registeredUserId");
            let Username = this.userSession.getLocalStorageItem('loginUserName');
            //console.log('Here set the registeredUserId');
            if (Username === prepopulatedUsername) {
              this.userSession.setLocalStorageItem('registeredUserId', '', { persist: true });
              let transTypeCd = 'M.02.009';
              let additionalData = { loginType: "Biomtric Login disabled" };
              this.loginSvc.trackGAEvent('Click:Login', 'Biomtric Login disabled');
              // this.memberAuditService.audit(transTypeCd, true, "0000", additionalData);
            }
            this.userSession.setLocalStorageItem('newUserNoTouhIdEnabled', 'true', { persist: true });
          }
        }
        else if (this.userSession.getLocalStorageItem('isRememberMeChecked') === 'true') {
          if (this.utilService.getNativeOS() === "iOS" || this.utilService.getNativeOS() === "Android") { //Android-Touch
            this.userSession.setLocalStorageItem('touchIdStatus', 'false', { persist: true });
            this.userSession.setLocalStorageItem('touchIdAuth', 'false', { persist: true });
            if (this.utilService.getNativeOS() === "iOS" || this.utilService.getNativeOS() === "Android") { //Android-Touch
              let touchIdStatusFlag = this.userSession.getLocalStorageItem('touchIdStatus');
              if (this.userSession.getLocalStorageItem('newUserNoTouhIdEnabled') === 'false') {
                this.nativeSvc.invokeNativeService(this.utilService.getNativeOS(), "updateTouchIdStatusFlag", touchIdStatusFlag);
              }
              else {
                if (this.userSession.getLocalStorageItem("touchid") == "true") {
                  this.userSession.setLocalStorageItem('touchIdStatus', 'true', { persist: true });
                }
                else {
                  this.userSession.setLocalStorageItem('touchIdStatus', 'false', { persist: true });
                }
              }
            }
            this.userSession.setLocalStorageItem('newUserNoTouhIdEnabled', 'true', { persist: true });
          }
        }
      }
      else {
        if (this.userSession.getLocalStorageItem('touchIdAuth') === 'false' && this.userSession.getLocalStorageItem('enabledUserNormalLoginFlow') === 'false') {
          this.userSession.setLocalStorageItem('newUserNoTouhIdEnabled', 'true');
        }
      }
    }

    if (this.utilService.getNativeOS() === "iOS" || this.utilService.getNativeOS() === "Android") { //Android-Touch
      if (this.userSession.getLocalStorageItem('isRememberMeChecked') === 'true' ||
        this.userSession.getLocalStorageItem('isEnableTouchIDChecked') === 'true') {
        let newTouchIdUser = this.userSession.getLocalStorageItem("newUser");
        touchIdStatusFlag = this.userSession.getLocalStorageItem('touchIdStatus');
        if (touchIdStatusFlag == null || touchIdStatusFlag == undefined) {
          touchIdStatusFlag = false;
        }
        this.userSession.setLocalStorageItem('loginUserName', username ? username : null, { persist: true });
        this.userSession.setLocalStorageItem('loginPassword', password ? password : null, { persist: true });
        if (newTouchIdUser == "true" && this.userSession.getLocalStorageItem('isRememberMeChecked') === 'true' && this.userSession.getLocalStorageItem("touchid") == "true") {
          this.nativeSvc.invokeNativeService(this.utilService.getNativeOS(), "storeNewUsersCredentials", username + ',' + password + ',' + touchIdStatusFlag);
          this.nativeSvc.invokeNativeService(this.utilService.getNativeOS(), "registerTouchID", username + ',' + password + ',' + touchIdStatusFlag);
        }
        else if (newTouchIdUser == "true" && this.userSession.getLocalStorageItem('isRememberMeChecked') === 'true') {
          this.nativeSvc.invokeNativeService(this.utilService.getNativeOS(), "registerTouchID", username + ',' + password + ',' + touchIdStatusFlag);
        }
        else if (newTouchIdUser == "true" && this.userSession.getLocalStorageItem("touchid") == "true") {
          this.nativeSvc.invokeNativeService(this.utilService.getNativeOS(), "storeNewUsersCredentials", username + ',' + password + ',' + touchIdStatusFlag);
          this.nativeSvc.invokeNativeService(this.utilService.getNativeOS(), "registerTouchID", username + ',' + password + ',' + touchIdStatusFlag);
        }
        else {
          this.nativeSvc.invokeNativeService(this.utilService.getNativeOS(), "registerTouchID", username + ',' + password + ',' + touchIdStatusFlag);
        }
      }
    }

    // if (this.utilSvc.getNativeOS() !== "iOS" && this.utilSvc.getNativeOS() !== "Android") { //Android-Touch              
    //   this.userSession.setLocalStorageItem('loginUserName', null);
    // }

    this.userSession.setLocalStorageItem('loginPassword', null);
    if (this.userSession.getLocalStorageItem("touchid") == "true" && this.userSession.getLocalStorageItem('touchIdStatus') == "true") {
      this.userSession.setLocalStorageItem('newUserNoTouhIdEnabled', 'false', { persist: true });//here new user touch enable true
    }

    if (username != undefined ||
      username != null || username != '') {
      username = username.toUpperCase().trim();
      this.nativeSvc.loggingInUserName = username.toUpperCase().trim();
    }

    // // also setting cookie here since preLogin might not set it?
    // // TODO: investigate prelogin flow
    this.userSession.setCookie('theUserID', username);

    // this.userSession.setLocalStorageItem('needGlobalConsent', false);
    //console.log('UserName', username);
    //console.log('password:', password);
    // // attempt login
    if (username != '' && password != '') {
      this.showLoader = true;
    }
  }

  /**
   * On Authentication check 
   */
  clickedOnAuthentication() {
    console.log("hi in clickedOnAuthentication");
    if (this.utilService.getNativeOS() === "iOS" || this.utilService.getNativeOS() === "Android") { //Android-Touch
      // n //console.log("Line No 881,step in clickedOnAuthentication function");
      // alert('line 917 ,invoke native service for isTochIdEnabled');
      this.nativeSvc.invokeNativeService(this.utilService.getNativeOS(), 'isTouchIdEnabled', '');
    }
  }

  /**
   * Android-Touch
   */
  isLoginLoaded() {
    //console.log("control in isLoginLoaded function ");
    //fix for Android:login page Enable Touch Id invisible at first login attempt
    setTimeout(() => {
      this.iOSCompatible = this.userSession.getLocalStorageItem('compatible');
      if (this.iOSCompatible == "true" || this.iOSCompatible == "faceID") {
        //console.log("this.iOSCompatible:" + this.iOSCompatible);
        this.iosCompatibleCheck = true;
      }

      if (this.userSession.getLocalStorageItem('touchid') == "true") {
        this.changeFingerprintCheckboxToCheckedORUnchecked(true);
      } else {
        this.changeFingerprintCheckboxToCheckedORUnchecked(false);
      }
    }, 1000);
  }
//   toggleShow() {
//     var btnText = document.getElementById("myBtn");
//     var vision = document.getElementById("vision");
//     this.show = !this.show;
//     if (this.show) {
//      // this.type = "text";
//       btnText.innerHTML = "Hide Passwords";
//      // document.getElementById("input39").type = 'text';
//       this.isHidePassword = true;
//     }
//     else {
//       this.type = "password";
//       btnText.innerHTML = "Show Passwords";
//       this.isHidePassword = false;
//     }
//   }
  getClientID(type) {
    const env = this.utilService.getEnvName();
    const zenv = this.userSession.getSession('zenv');
    let client_id;
    if (type === 'SHOPPER') {
      if (env === 'dev') {
        client_id = ClientId_SHOPPER.DEV;
      } else if (env === 'sita') {
        client_id = ClientId_SHOPPER.SIT;
      } else if (env === 'uat') {
        client_id = ClientId_SHOPPER.UAT;
      } else if (env === 'tt') {
        if (zenv && zenv === 'sit') {
          client_id = ClientId_SHOPPER.SIT;
        }
        else {
          client_id = ClientId_SHOPPER.TT;
        }
      } else {
        client_id = ClientId_SHOPPER.PROD;
      }
    } else {
      if (env === 'dev') {
        client_id = ClientId_MEMBER.DEV;
      } else if (env === 'tt') {
        client_id = ClientId_MEMBER.TT;
      } else if (env === 'sita') {
        client_id = ClientId_MEMBER.SIT;
      } else if (env === 'uat') {
        client_id = ClientId_MEMBER.UAT;
      } else {
        client_id = ClientId_MEMBER.PROD;
      }
    }
    return client_id;
  }

}





// WEBPACK FOOTER //
// ./src/app/new-login-widget/new-login-widget.component.ts